var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#18A7B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5723 6C29.9569 6 30.2686 6.31166 30.2686 6.69629V8.84082H33.8574L34.0762 8.85156C35.1567 8.96124 35.9999 9.87399 36 10.9834V36.6982L35.9893 36.917C35.8869 37.9256 35.0848 38.7277 34.0762 38.8301L33.8574 38.8408H8.14258C7.03317 38.8407 6.12042 37.9975 6.01074 36.917L6 36.6982V10.9834C6.00015 9.80015 6.95933 8.84097 8.14258 8.84082H11.3564V6.69629C11.3564 6.31166 11.6681 6 12.0527 6C12.4374 6 12.749 6.31166 12.749 6.69629V8.84082H28.876V6.69629C28.876 6.31166 29.1876 6 29.5723 6ZM8.14258 10.127C7.66941 10.1271 7.28628 10.5102 7.28613 10.9834V36.6982C7.28628 37.1714 7.66941 37.5545 8.14258 37.5547H33.8574C34.3306 37.5545 34.7137 37.1714 34.7139 36.6982V10.9834C34.7137 10.5102 34.3306 10.1271 33.8574 10.127H30.2686V12.0537C30.2684 12.4382 29.9568 12.75 29.5723 12.75C29.1877 12.75 28.8761 12.4382 28.876 12.0537V10.127H12.749V12.0537C12.7489 12.4382 12.4373 12.75 12.0527 12.75C11.6682 12.75 11.3566 12.4382 11.3564 12.0537V10.127H8.14258Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2508b070993787f548f70fc1df03d4f6.svg";
export { ForwardRef as ReactComponent };